import { render, staticRenderFns } from "./IconAndroidAddToHome.vue?vue&type=template&id=31817d00&scoped=true"
import script from "./IconAndroidAddToHome.vue?vue&type=script&lang=js"
export * from "./IconAndroidAddToHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31817d00",
  null
  
)

export default component.exports